import React from 'react'
import { Navigate } from "react-router-dom";


export default function PublicRoute(props) {
  return (
    (!props.isAuthenticated)
    ? ( props.component )
    : ( <Navigate replace to="/" /> )
  )
}
